require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2009-06-19-new-iphone-camera.json") })
        }
      }, "path---articles-2009-06-19-new-iphone-camera");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2009-06-19-new-iphone-camera!./.cache/json/articles-2009-06-19-new-iphone-camera.json
// module id = 568
// module chunks = 231608221292675